import TimeOffPolicies from './TimeOffPolicies';

export default TimeOffPolicies;
